var jwtHelper = (function () {
    function jwtHelper() {
    }
    jwtHelper.prototype.validateToken = function (token) {
        var output = token.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: {
                break;
            }
            case 2: {
                output += '==';
                break;
            }
            case 3: {
                output += '=';
                break;
            }
            default: {
                throw 'Illegal base64url string!';
            }
        }
        return output;
    };
    jwtHelper.prototype.encodeToken = function (token) {
        try {
            //const encoded: string = encodeURIComponent(encodeURI(window.btoa(token))); //polifyll https://github.com/davidchambers/Base64.js            
            var encoded = encodeURIComponent(window.btoa(token)); //polifyll https://github.com/davidchambers/Base64.js            
            return encoded;
        }
        catch (e) {
            throw new Error('Cannot encode the token');
        }
    };
    jwtHelper.prototype.updateCookie = function (cookie, token) {
        // Insert the new encoded token into the existing cookie's 2nd 
        var parts = cookie.split('.'); // split it
        parts[1] = token; // add updated user data into the 2nd element
        return parts.join('.'); // merge again
    };
    jwtHelper.prototype.decodeToken = function (token) {
        var parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('JWT must have 3 parts');
        }
        try {
            var vt = this.validateToken(parts[1]);
            var decoded = decodeURIComponent(encodeURI(window.atob(vt))); //polifyll https://github.com/davidchambers/Base64.js            
            return JSON.parse(decoded);
        }
        catch (e) {
            throw new Error('Cannot decode the token');
        }
        //        const decoded: string = this.base64Decode(parts[1]);
        //       if (!decoded) {
        //          throw new Error('Cannot decode the token');
        //    }
        //return JSON.parse(decoded);
    };
    jwtHelper.prototype.getTokenExpirationDate = function (token) {
        var decoded;
        decoded = this.decodeToken(token);
        if (typeof decoded.exp === "undefined") {
            return null;
        }
        var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
        d.setUTCSeconds(decoded.exp);
        return d;
    };
    jwtHelper.prototype.isTokenExpired = function (token, offsetSeconds) {
        var d = this.getTokenExpirationDate(token);
        offsetSeconds = offsetSeconds || 0;
        if (d === null) {
            return false;
        }
        // Token expired?
        var t = (d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
        return !t;
    };
    return jwtHelper;
}());
angular
    .module('application')
    .service('jwtHelper', jwtHelper);

//# sourceMappingURL=jwt.js.map
